import { render, staticRenderFns } from "./ShorexSummary.vue?vue&type=template&id=a152dd5e&scoped=true"
import script from "./ShorexSummary.vue?vue&type=script&lang=js"
export * from "./ShorexSummary.vue?vue&type=script&lang=js"
import style0 from "./ShorexSummary.vue?vue&type=style&index=0&id=a152dd5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152dd5e",
  null
  
)

export default component.exports